export default __webpack_public_path__ + "static/media/WIBS about graphic 1.a91a2ad0.png";